<template>
  <div class="servelist">
    <div class="servelist-top">
      <Form ref="selectForm" :model="serve" :label-width="90" class="tabTopForm">
        <FormItem label="当前状态">
          <Select
            class="select"
            v-model="serve.state"
            clearable
            placeholder="请选择状态"
            @on-change="searchServe"
            @on-clear="searchServe"
          >
            <Option v-for="item in stateList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="服务场景">
          <Select
            class="select"
            v-model="serve.scene"
            clearable
            placeholder="请选择场景"
            @on-change="searchServe"
            @on-clear="searchServe"
          >
            <Option v-for="item in sceneList" :value="item.v" :key="item.v">{{ item.k }}</Option>
          </Select>
        </FormItem>
        <FormItem label="服务提供者">
          <Input
            clearable
            v-model.trim="serve.proName"
            placeholder="请输入服务提供者名称"
            style="width: 100%; min-width: 150px"
            class="inputName"
            @on-blur="searchServe"
            @on-clear="searchServe"
            @on-enter="searchServe"
          />
        </FormItem>
        <FormItem label="创建时间" class="scene">
          <DatePicker
            v-model="serve.createTime"
            format="yyyy/MM/dd"
            type="daterange"
            placement="bottom-end"
            placeholder="请选择创建时间"
            transfer
            :editable="false"
            @on-change="
              changeTime();
              searchServe();
            "
            @on-blur="searchServe"
            @on-clear="searchServe"
            style="width: 220px"
          ></DatePicker>
        </FormItem>
        <FormItem label class="name">
          <Input
            clearable
            v-model.trim="serve.serviceName"
            placeholder="请输入服务名称"
            class="inputName"
            @on-blur="searchServe"
            @on-clear="searchServe"
            @on-enter="searchServe"
          />
        </FormItem>
      </Form>
    </div>
    <div class="servelist-content">
      <Row>
        <Table
          class="tableDom"
          ref="tableRef"
          stripe
          :columns="dataCol"
          :loading="tableLoading"
          :data="dataList"
        >
          <!-- 序号 -->
          <template slot-scope="{ index }" slot="xuhao">
            {{
            index + 1
            }}
          </template>
          <!-- logo -->
          <template slot-scope="{ row }" slot="logo">
            <img :src="row.imgUrl" alt class="logo" v-if="row.imgUrl != undefined" />
            <img v-else src="@/assets/img/avatar.png" class="logo" />
          </template>
          <!-- 当前状态0未上架 1已上架 2已下架 3待下架  4下架申请（属于已上架）-->
          <template slot-scope="{ row }" slot="state">
            <div v-if="row.status == 4 || row.status == 1">
              <span class="dot1"></span>
              已上架
            </div>
            <div v-if="row.status == 3">
              <span class="dot4"></span>
              待下架
            </div>
            <div v-if="row.status == 2">
              <span class="dot2"></span>
              已下架
            </div>
            <div v-if="row.status == 0">
              <span class="dot3"></span>
              未上架
            </div>
            <div v-if="row.status == 5">
              <span class="dot3"></span>
              下架审核中
            </div>
          </template>
          <!-- 操作 -->
          <template slot-scope="{ row }" slot="action">
            <span
              class="fontblue fontcursor mr-16"
              @click="link('/serve/serveinfo', row)"
              v-permission="['detail']"
            >查看详情</span>
            <Poptip confirm title="是否下架该服务？"  :transfer="true" @on-ok="offShelf(row)">
              <span class="fontblue fontcursor mr-16" v-permission="['service_off']" v-if="row.status == 1">下架</span>
            </Poptip>
          </template>
        </Table>
      </Row>
      <Row class="mt-16 mr-32" type="flex" justify="end">
        <Page
          :total="pageTotal"
          :page-size="pageSize"
          :page-size-opts="psize"
          :current="pageNum"
          @on-change="handlePage"
          @on-page-size-change="sizeChange"
          show-sizer
          show-total
          show-elevator
          placement="top"
          class-name="page"
        />
      </Row>
    </div>
  </div>
</template>

<script>
import { serviceList, offService } from "@/api/service";
import { getDict } from "@/api/dict";
import TableMixin from "@/utils/mixins/tableMixin";
const dataCol = [
  {
    title: "序号",
    slot: "xuhao",
    tooltip: true,
    minWidth: 70
  },
  {
    title: "服务logo",
    slot: "logo",
    tooltip: true,
    minWidth: 100
  },
  {
    title: "服务ID",
    key: "id",
    tooltip: true,
    minWidth: 100
  },
  {
    title: "服务提供者",
    key: "providerName",
    tooltip: true,
    minWidth: 110
  },
  {
    title: "服务名称",
    key: "name",
    align: "center",
    tooltip: true,
    minWidth: 110
  },
  {
    title: "服务场景",
    key: "sence",
    tooltip: true,
    minWidth: 150
  },
  {
    title: "当前状态",
    slot: "state",
    tooltip: true,
    minWidth: 140
  },
  {
    title: "评分",
    key: "score",
    tooltip: true,
    minWidth: 100
  },
  {
    title: "使用次数",
    key: "usedCount",
    tooltip: true,
    minWidth: 110
  },
  {
    title: "使用量",
    key: "usedAmount",
    tooltip: true,
    minWidth: 100
  },
  {
    title: "视频接入量",
    key: "resourceCount",
    tooltip: true,
    minWidth: 110,
    maxWidth: 110
  },
  {
    title: "创建时间",
    key: "createTime",
    tooltip: true,
    minWidth: 210
  },
  {
    title: "操作",
    slot: "action",
    fixed: "right",
    minWidth: 240
  }
];
export default {
  components: {},
  mixins: [mixins, TableMixin],
  data() {
    return {
      Recovery: {
        path: ["/serve/serveinfo"],
        key: ["serve", "pageSize", "pageNum"]
      },
      tableLoading: false,
      pageTotal: 0,
      pageSize: 10, //每页数量
      psize: [10, 20, 50, 100],
      pageNum: 1, //第几页
      serve: {
        state: "",
        scene: "",
        proName: "",
        createTime: [],
        serviceName: ""
      },
      stateList: [
        {
          id: 0,
          name: "未上架"
        },
        {
          id: 1,
          name: "已上架"
        },
        {
          id: 2,
          name: "已下架"
        },
        {
          id: 3,
          name: "待下架"
        },
        {
          id: 5,
          name: "下架审核中"
        }
      ],
      sceneList: [], //服务场景
      dataList: [],
      dataCol: dataCol,
      search: {
        name: ""
      },
      showDialog: false,
      type: "add",
      dataForm: {},
      K: ""
    };
  },
  created() {
    this.serve.createTime.length > 0 &&
      (this.serve.createTime = [
        this.$moment(this.serve.createTime[0]).format("YYYY-MM-DD HH:mm"),
        this.$moment(this.serve.createTime[1]).format("YYYY-MM-DD HH:mm")
      ]);
    let self = this;
    this.getScenceList(); //获取服务场景
  },
  mounted() {
    this.isManager = _GLOBAL.isManager();
    this.userRole = _GLOBAL.isCertified();
  },
  computed: {},
  methods: {
    // 下架
    async offShelf(row) {
      try {
        console.log("row", row);
        let {
          data: { code }
        } = await offService(row.id);
        this.getList();
        this.$Message.success("下架成功！");
      } catch (e) {
        console.log(e);
      }
    },
    //获取创建时间
    changeTime() {
      console.log("time", this.serve.createTime);
    },
    // 服务场景（字典）
    getScenceList() {
      getDict("SERVICE_SCENE").then(res => {
        if (res.data.code == 0) {
          this.sceneList = res.data.data;
          this.getList(); //获取服务列表
        } else {
          console.log("请求数据失败");
        }
      });
    },
    // 获取服务管理列表
    getList() {
      if (this.serve.createTime.length && this.serve.createTime[0] != "") {
        this.serve.createTimeBegin = this.$moment(
          this.serve.createTime[0]
        ).format("YYYY-MM-DD");
        this.serve.createTimeEnd =
          this.$moment(this.serve.createTime[1]).format("YYYY-MM-DD") +
          " 23:59:59";
      } else {
        delete this.serve.createTimeBegin;
        delete this.serve.createTimeEnd;
      }
      let query = {
        status: this.serve.state,
        serviceScene: this.serve.scene,
        providerName: this.serve.proName,
        createTimeBegin: this.serve.createTimeBegin,
        createTimeEnd: this.serve.createTimeEnd,
        serviceName: this.serve.serviceName,
        pageIndex: this.pageNum,
        pageSize: this.pageSize
      };
      console.log("query", query);
      serviceList(query).then(res => {
        let json = res.data.data;
        this.pageTotal = res.data.page.totalCount;
        this.dataList = json;
        console.log("服务管理列表", this.dataList);
        // 服务场景转换（将id数组，转换为id对应名称并且以，分割的字符串）
        if (this.dataList && this.dataList) {
          this.dataList.forEach(item => {
            item.score.toString().indexOf(".") == -1 ||
              (item.score = item.score.toFixed(1));
            item.serviceSceneList.forEach((x, index) => {
              let t = this.sceneList.find(y => y.v == x);
              if (t) {
                item.serviceSceneList[index] = t.k;
              }
            });
            item.sence = item.serviceSceneList.join(",");
          });
        }
      });
    },
    // 分页==页码修改(ok)
    handlePage(value) {
      let self = this;
      self.pageNum = value;
      self.getList();
    },
    // 分页==每页显示数量修改(ok)
    sizeChange(value) {
      let self = this;
      self.pageSize = value;
      self.$nextTick(() => {
        self.getList();
      });
    },
    // 查询服务
    searchServe() {
      this.pageNum = 1;
      // this.pageSize = 10;
      this.getList();
    },
    link(path, item) {
      if (item) {
        this.$router.push({
          path: path,
          query: {
            id: item.id
          }
        });
      } else {
        this.$router.push({ path: path });
      }
    }
  }
};
</script>

<style lang="scss">
.servelist {
  width: 100%;
  height: 100%;
  background: #fff;
  &-top {
    width: 100%;
    padding: 20px;
    margin-bottom: -30px;
    .tabTopForm {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      .ivu-select-single .ivu-select-selection {
        height: 36px;
        padding-top: 2px;
        min-width: 150px;
      }
      .scene {
        margin-right: -80px;
      }
      .name {
        margin-right: -70px;
        .inputName {
          min-width: 150px;
        }
      }
    }
    .btn {
      width: 130px;
      height: 36px;
      border-radius: 18px;
      margin-left: 0px;
    }
  }
  &-content {
    .state {
      max-width: 70px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .tableDom {
    width: 100%;
    .logo {
      width: 36px;
      height: 36px;
      border-radius: 50%;
    }
    .dot1 {
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #67c23a;
      border-radius: 50%;
    }
    .dot2 {
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #f56c6c;
      border-radius: 50%;
    }
    .dot3 {
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #3c8aff;
      border-radius: 50%;
    }
    .dot4 {
      display: inline-block;
      width: 6px;
      height: 6px;
      background: orange;
      border-radius: 50%;
    }
  }
}
</style>
